import { useIcons, Drsanje, Pravljicno } from "kzv-icons"
import PoiType from "src/models/PoiType"

const poiTypeslugIconsMapper = {
  drsalisce: Drsanje,
  "pravljicna-pot": Pravljicno,
}

interface PoiTypeIconProps {
  poiType: PoiType
  size?: string
}

function PoiTypeIcon({ poiType, size = "24px", ...rest }: PoiTypeIconProps) {
  const { poiTypesIcons } = useIcons()

  const Icon = poiTypesIcons[poiType.slug] ?? poiTypeslugIconsMapper[poiType.slug]

  if (!Icon) {
    return null
  }

  return <Icon style={{ width: size, height: size }} {...rest} />
}

export default PoiTypeIcon
